import '@tailwindplus/elements';
import { createApp } from 'vue'
import InstantSearch from "vue-instantsearch/vue3/es";
import Search from "./Search.vue";

const app = createApp(Search, {
    appId: window.ignet.AlgoliaSearchAppID,
    apiKey: window.ignet.AlgoliaSearchApiKey,
    indexes: window.ignet.AlogliaSearchIndexes,
    indexPrefix: window.ignet.AlgoliaSearchIndexPrefix,
});
app.use(InstantSearch);
app.mount("#search");
